"use client";

import React from "react";
import Link from "next/link";

const StartJourneyCta: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Start Your Invisalign Journey Today
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          The difference Invisalign makes, before and after treatment, can be
          life-changing. Whether you&apos;re dealing with crowded teeth, gaps,
          or bite misalignment, clear aligners offer a discreet, comfortable,
          and effective path forward.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          At Smile4Me Dental Care, every plan is built specifically for you
          using advanced 3D imaging and in-house expertise. You won&apos;t be
          passed between providers or handed generic advice. You get a
          dedicated team that sees your case through from start to finish,
          right here in Astoria.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          We&apos;re located at 31-57 Steinway St, Queens, NY 11103. Call us at{" "}
          <a
            href="tel:+17184004400"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            (718) 400-4400
          </a>
          ,{" "}
          <Link
            href="https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            book an appointment online
          </Link>
          , or walk in for a same-day consultation.
        </p>
      </div>
    </section>
  );
};

export default StartJourneyCta;
